import Handlebars from 'handlebars';
import i18n from 'l10n';
import Template from 'js/templates/message.mail.hbs';
import SpamAssassinTemplate from 'js/templates/partials/spam.assassin.partial.hbs';
import PhishingTemplate from 'js/templates/partials/phishing.partial.hbs';
import AtdTemplate from 'js/templates/partials/atd.partial.hbs';
import GuessLanguage from 'guessLanguage';
import layoutManifest from 'js/models/mosaico.layouts.manifest';
import dhtmlx from 'dhtmlxAdapter';
import {_, Backbone} from "backboneAdapter";
import {debounce, el, on, template} from "js/adapters/backbone-decorators";
import MessageGenericView from "./message.generic.view";
import {handles} from "../adapters/backbone-decorators";

require('metroHint2');

let getSearchableText = function( elem ) {
    var node,
        ret = "",
        i = 0,
        nodeType = elem.nodeType;

    if ( !nodeType ) {
        // If no nodeType, this is expected to be an array
        while ( (node = elem[i++]) ) {
            // Do not traverse comment nodes
            ret += getSearchableText( node ) + ' ';
        }
    } else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
        // Traverse its children
        for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
            ret += getSearchableText( elem ) + ' ';
        }
    } else if ( nodeType === 3 || nodeType === 4 ) {
        return elem.nodeValue;
    }
    // Do not include comment or processing instruction nodes

    return ret;
};

@template(Template)
@el("#edit-mail-message")
class MessageMailView extends MessageGenericView {

    constructor(options) {
        super(options);
        this.isContactsCountValid = false;
        this.isHtmlContentValid = false;
        this.messageContainsPlaceholders = false;
        this.spamAssassinTemplate = Handlebars.compile(SpamAssassinTemplate);
        this.phishingTemplate = Handlebars.compile(PhishingTemplate);
        this.atdTemplate = Handlebars.compile(AtdTemplate);
        this.useAtd = false;
        this.confMessage = '';
        this.once = false;
        this.errors = [];
        this.isSpamPhisCheckActive = false; //if true: `YOUR EMAIL IS BEING PROCESSED BY SPAM FILTER` message is visible
        this.guessLanguage = GuessLanguage.guessLanguage; //`GuessLanguage` returns an object with the property `guessLanguage`
        this.isSms = false;
        this.loadInner().always(() => {
            //this.superInitialize(options);
            this.on("spamResult", response => {
                console.info(response);
                if (this.model.get("id") === response.id) {
                    $("#spamProcessing").hide();

                    this.model.set("spamPhisResponse", {
                        "isSpam": response.isSpam,
                        "phisResult": response.phisResult.underlying,
                        "spamScore": response.spamScore,
                        "spamThreshold": response.spamThreshold,
                        "spamdResponse": response.spamdResponse
                    });

                    this.isSpamPhisCheckActive = false;
                    this.toggleButtons(this.checkMessageIfReady(this));
                }
            });
            if (this.checkMessageIfReady(this)) {
                this.toggleButtons(true);
            } else {
                this.toggleButtons(false);
            }
        });
    }

    showOrHideSpamSpoofReport() {
        var self = this;
        var spamPhisResponse = this.model.get("spamPhisResponse");
        if (!spamPhisResponse) {
            return;
        }
        var partial;
        var $spamResultSection = $("#spamResultSection");
        if (spamPhisResponse.isSpam) {
            partial = self.spamAssassinTemplate({
                points: spamPhisResponse.spamScore,
                threshold: spamPhisResponse.spamThreshold,
                spamResponse: spamPhisResponse.spamdResponse
            });
            $spamResultSection.html(partial);
            $spamResultSection.show();
        } else {
            $spamResultSection.hide();
        }

        var $phishingResultSection = $("#phishingResultSection");
        if (spamPhisResponse.phisResult && spamPhisResponse.phisResult.length > 0) {
            var warnings = _.map(spamPhisResponse.phisResult, function (w) {
                var n = _.extend({}, w);

                if (n.text) {
                    n.text = n.text;
                }

                if (n.spoofed) {

                    var decoded = decodeURIComponent(n.spoofed)
                    decoded = decoded.replace(/([^a-zA-Z0-9]+)/g, "$1"); //for possible future usage

                    n.spoofed = decoded;
                    n.scripts = self.guessLanguage.findRuns(n.spoofed);
                }

                return n;
            });
            partial = self.phishingTemplate(warnings);
            $phishingResultSection.html(partial);
            $phishingResultSection.show();
        } else {
            $phishingResultSection.hide();
        }
    }

    handleUpdate(value, settings, e) {
        const classes = $(e).attr("class");
        const isMessage = classes.includes("attr:message") || $(e).data("prop") === "message";
        if (isMessage || classes.includes("attr:title") || $(e).data("prop") === "title") {
            $("#spamProcessing").show();
            $("#spamResultSection").hide();
            this.isSpamPhisCheckActive = true;
        }
        if (isMessage) {
            if (this.useAtd) {
                $("#atdSection").hide();
                let textValue = getSearchableText($('<p></p>').html(value));
                this.invokeAtd(textValue);
            }
        }
        super.handleUpdate(value, settings, e);
    }

    loadInner() {
        return $.ajaxDefaultQ({
            url: '/CampaignCloud/Message/getFooter',
            type: 'GET',
            contentType: 'application/json'
        }).done(response => {
            this.standardFooter = response.footer;
        }).fail(function () {
            console.error("Failed to get standard footer");
        });
    }

    render() {
        var footerHeight = 0;
        var displayedLayouts = _.filter(layoutManifest, function (v) {
            return v.languages.hasOwnProperty(i18n.language);
        });
        var extModel = {layouts: displayedLayouts};
        super.render(extModel);
        if (this.whitelist != undefined) {
            this.showWhitelist();
        }
        if (this.standardFooter) {
            var $footer = $("<div>")
                .html(this.standardFooter)
                .addClass("email-footer")
                .appendTo("#editor-tile");
            footerHeight = $footer.height();
        }

        //Check if Campaign has its message set and still awaits the spamAssassin response
        if (this.model.get("message")) {
            if (!this.model.get("spamPhisResponse") && this.isSpamPhisCheckActive)
                $("#spamProcessing").show();
        } else
            $(".email-footer").addClass("hide");

        //TODO REFACTOR
        //Check if Mosaico is being used and resize iframe when it completes rendering.
        var $editable = $("#message-editable");
        var $mosaico = $("#message-mosaico");
        let $mask = $("#editor-tile").find(".iframe-mask");

        if ($mosaico.length > 0) {
//                if(self.model.get("message").match(/mosaico\/img\/?placeholder/))
            $mosaico.on('load', function () {
                var $ifrDoc = $mosaico.contents();
                var ifrImg = $ifrDoc.find('img');
                $.each(ifrImg, (ind, img) => {
                    if (img.src.match(/\/CampaignCloud\/mosaico\/img\/\?method=placeholder/))
                        this.messageContainsPlaceholders = true;
                });
                var $ifrBody = $ifrDoc.find('body');
                $mosaico.height($ifrBody.height());
                $mask.height($mosaico.height() + footerHeight);
                $mask.width($mosaico.width());
                $(".email-footer").attr('style', $ifrBody.attr('style'));
            });
        }
        $(this.el).on("jWysiwyg.tooBigDrop", () => {
            dhtmlx.alert(i18n.t("message.tooBigDrop"));
        });
        $(this.el).on("jWysiwyg.notImageDrop", () => {
            dhtmlx.alert(i18n.t("message.notImageDrop"));
        });
        $(this.el).on("jWysiwyg.tooBigPaste", () => {
            dhtmlx.alert(i18n.t("message.tooBigPaste"));
        });
        this.confMessage = this.model.get("message");
        return this;
    }

    //TODO check for WYSIWYG
    @on("focus #editor-tile")
    focusEdtr() {
        this.toggleButtons(false, this);
    }

    @on("click #mosaico-edit, #editor-tile #mask-mosaico")
    clickMsc() {
        this.enterMosaico(this);
    }

    @on("click #select-editor .templateSelection")
    clickEdtr(e) {
        this.selectEditor(e, this);
    }

    @on("click button[type=submit]")
    clickSbmt() {
        var $wysiwyg = $('.wysiwyg');
        var messageContent = $wysiwyg.find('iframe').contents().find('body').html();
        var messageContentOnSourceView = $wysiwyg.find('textarea').val();
        var txtAreaDisplay = $wysiwyg.find('textarea').css("display");
        if (messageContent !== messageContentOnSourceView && txtAreaDisplay !== "none") {
            $('.wysiwyg iframe').contents().find('body').html(messageContentOnSourceView);
        }
    }

    @debounce(300)
    @on("keyup .emailTemplateFilter")
    searchEmailThemes(e) { //keyup on Searchbox
        var self = this;
        var searchText = $(e.currentTarget).val().trim().toLowerCase();
        var templates = $(".templateSelectionTop");

        this.showAndHideThemesAccordingToFilters(searchText, templates);
    }

    @on("click .emailThemeFilter")
    filterEmailThemesByCategory(e) { //selected via the SELECT option
        var value = $(e.currentTarget).data("value").trim().toLowerCase();
        var templates = $(".templateSelectionTop");

        $(".emailTemplateFilter").val(''); //clear the searchbox
        this.showAndHideThemesAccordingToFilters(value, templates);
    }

    @on("click #clearEmailThemeFilter")
    clearEmailThemeFilter() {
        var self = this;
        var $resultsDiv = $("#filteredEmailThemesResults");
        var $resultsCounterAndText = $resultsDiv.find(".filteredTextResult");
        $resultsDiv.hide(); //hide and clear the "results found" text
        $resultsCounterAndText.empty();
        var $emailTemplateFilter = $(".emailTemplateFilter");
        $emailTemplateFilter.val(''); //clear the searchbox
        $emailTemplateFilter.trigger("keyup"); //trigger "keyup" event, so all choices will be visible
    }

    @on("click #execute-test")
    executeTest() {
        var self = this;
        if (!self.$("#execute-send").hasClass("cursor-not-allowed")) {
            var userMail = self.userModel.get("email");
            if (!userMail)
                dhtmlx.confirm({
                    type: "confirm",
                    text: i18n.t("message.fillinyourmail"),
                    ok: i18n.t("message.yes"),
                    cancel: i18n.t("message.later"),
                    callback: function (result) {
                        if (result)
                            location.href = "/CampaignCloud/cloudui/home/Profile.htm";
                    }
                });
            else {
                dhtmlx.confirm({
                    type: "confirm",
                    text: i18n.t("message.sendtestconfirm", {mail: userMail}),
                    ok: i18n.t("message.yes"),
                    cancel: i18n.t("message.no"),
                    callback: function (result) {
                        if (result)
                            $.ajaxDefaultQ({
                                url: '/CampaignCloud/Message/' + self.model.get("id") + '/test',
                                type: 'POST'
                            }).done(function (resp) {
                                $.Notify[(resp.outcome === "OK") ? "show" : "error"](i18n.t("message.testsent") + i18n.t("generic.=" + resp.outcome));
                            });
                    }
                });
            }
        }
    }

    validateContactsCount() {
        if (this.model.get("description") !== "tellody-event" && this.model.get("description") !== "birthday" && this.model.get("description") !== "nameday"
            && this.targetingSize <= 0) {
            this.isContactsCountValid = false;

            return {
                "type": i18n.t("message.error"),
                "description": i18n.t("message.selecttargetingtitle"),
                "value": i18n.t("message.messagenocontactsselectedoravailable")
            };
        } else {
            this.isContactsCountValid = true;

            return null;
        }
    }

    toggleTestButton(bool) {
        var self = this;
        if (!bool) {
            self.$("#execute-test").removeClass("bg-white bg-hover-white fg-green fg-hover-emerald ")
                .addClass("bg-white bg-hover-white fg-orange fg-hover-red cursor-not-allowed");
        } else {
            self.$("#execute-test").removeClass("bg-white bg-hover-white fg-orange fg-hover-red cursor-not-allowed")
                .addClass("bg-white bg-hover-white fg-green fg-hover-emerald ");
        }
    }

    // Changes XML to JSON. Mostly from: https://davidwalsh.name/convert-xml-json
    xmlToJson(xml) {

        // Create the return object
        var obj = {};

        if (xml.nodeType === 1) { // element
            // do attributes
            if (xml.attributes.length > 0) {
                obj["@attributes"] = {};
                for (var j = 0; j < xml.attributes.length; j++) {
                    var attribute = xml.attributes.item(j);
                    obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
                }
            }
        } else if (xml.nodeType === 3) { // text
            obj = xml.nodeValue;
        }

        // do children
        if (xml.hasChildNodes()) {
            for (var i = 0; i < xml.childNodes.length; i++) {
                var item = xml.childNodes.item(i);
                var nodeName = item.nodeName;
                //if(nodeName == '#text') nodeName = '_text';
                if (typeof (obj[nodeName]) == "undefined") {
                    obj[nodeName] = this.xmlToJson(item);
                } else {
                    if (typeof (obj[nodeName].push) == "undefined") {
                        var old = obj[nodeName];
                        obj[nodeName] = [];
                        obj[nodeName].push(old);
                    }
                    obj[nodeName].push(this.xmlToJson(item));
                }
            }
        }
        return obj;
    }

    @debounce(50)
    invokeAtd(html) {
        var self = this;
        this.guessLanguage.detect(html, function (language) {
            console.log('Detected language code of text is [' + language + ']');
            if (language === "en") {
                $.ajaxDefaultQ({
                    url: '/atd/checkDocument',
                    type: 'POST',
                    data: {key: '000000000000', data: html}
                }).done(function (data) {
                    var j = self.xmlToJson(data);
                    console.log(j);
                    var $atdSection = $("#atdSection");
                    if (j.results.error) {
                        var initialErrors = j.results.error.length ? j.results.error : [j.results.error];
                        var errors = _.filter(initialErrors, function (er) {
                            return er.string && er.string['#text'] !== 'cant';
                        });
                        _.forEach(errors, function (er) {
                            if (er.url) {
                                er.url['#text'] = '/atd' + er.url['#text'].substr(36); //Cut https://service.afterthedeadline.com
                            }
                        });
                        var html = self.atdTemplate({error: errors});
                        $atdSection.html(html);
                        $atdSection.show();
                    } else {
                        $atdSection.hide();
                    }
                }).fail(function () {
                    console.log('Could not query AtD');
                });
            }
        });
    }

    validateHtmlContent() {
        var self = this;
        var $wysiwyg = $('.wysiwyg iframe');
        var $message = $('#message-editable');
        var $message2 = $('#message-mosaico');
//        var html = $("#editor-tile").hasClass("hide") ? "" : $('.iframe-editable')[0].contentDocument.body.innerHTML;
        var html = $("#editor-tile").hasClass("hide") ? ""
            : $wysiwyg.length > 0 ?
                $wysiwyg.contents().find('body').text()
                : $message.length > 0 ?
                    $message.html()
                    : $message2.length > 0 ?
                        $message2[0].contentDocument.body.innerHTML
                        : "";
        if (!html || html.includes("<placeholder>")) {
            this.isHtmlContentValid = false;
            return {
                "type": i18n.t("message.error"),
                "description": i18n.t("message.emptyField"),
                "value": i18n.t('message.emptyMessageContent')
            };
        } else {
            this.isHtmlContentValid = true;
            return null;
        }
    }

    checkMessageIfReady() {
        this.showOrHideSpamSpoofReport();
        return !(!this.isUrlValid || !this.isVoucherValid || !this.isSurveyValid || !this.isCampaignValid
            || !this.isMessageSaved || !this.isContentValid || !this.isHtmlContentValid || this.messageContainsPlaceholders
            || !this.isContactsCountValid || this.isSpamPhisCheckActive || (this.model.get("spamPhisResponse") &&
                (this.model.get("spamPhisResponse").isSpam || this.model.get("spamPhisResponse").phisResult)));
    }

    @handles("selected:triggeredEvent")
    @handles("opened:EditingSelectingContent")
    validateMessageCondition() {
        this.errors = [];

        var urlValidation = this.validateUrl();
        if (urlValidation && !$("#url-editable").find("form").length) //do not show the error, while the element is currently getting edited) {
            this.errors.push(urlValidation);

        var voucherValidation = this.validateVoucher();
        if (voucherValidation && $($("#voucher-options").find(".heading")[0]).hasClass("collapsed")) //do not show the error, while the element is currently getting edited) {
            this.errors.push(voucherValidation);

        var surveyValidation = this.validateSurvey();
        if (surveyValidation && $($("#survey-options").find(".heading")[0]).hasClass("collapsed")) //do not show the error, while the element is currently getting edited) {
            this.errors.push(surveyValidation);

        var contentValidation = this.validateContent();
        if (contentValidation && $($("#select-file-content").find(".heading")[0]).hasClass("collapsed")) //do not show the error, while the element is currently getting edited) {
            this.errors.push(contentValidation);

        if (this.campaignView) {
            var campaignValidation = this.validateCampaign();
            if (campaignValidation && $($("#triggering-event").find(".heading")[0]).hasClass("collapsed")) //do not show the error, while the element is currently getting edited) {
                this.errors.push(campaignValidation);
        }

        var $message = $("#message-editable");
        if ($message.find("form").length > 0) {
            this.errors.push({
                "type": i18n.t("message.error"),
                "description": i18n.t("message.nonSavedMessageContent"),
                "value": i18n.t('message.warningsaveordiscard')
            });
        }

        if (this.messageContainsPlaceholders) {
            this.errors.push({
                "type": i18n.t("message.error"),
                "description": i18n.t("message.emptyField"),
                "value": i18n.t('message.nonUsedImagePlaceholderMessage')
            });
        }

        var contactsCountValidation = this.validateContactsCount(this);
        if (contactsCountValidation && this.model.get("campaignTemplateType") !== "SMART_NOTIFICATION")
            this.errors.push(contactsCountValidation);

        var htmlValidation = this.validateHtmlContent();
        if (htmlValidation && !$message.find("form").length) //do not show the error, while the element is currently getting edited) {
            this.errors.push(htmlValidation);
        this.updateMessageCount();

        if (this.errors.length > 0)
            this.showErrors(this.errors);
        else
            this.hideErrors();

        if (!this.isTriggeredByKeyPress && this.model.get("description") === 'tellody-event')
            this.getDependenciesSmsCount();
        this.updateGraph();
        if (this.checkMessageIfReady(this)) {
            this.toggleButtons(true);
            return true;
        } else {
            this.toggleButtons(false);
            return false;
        }
    }

    execute() {
        var self = this;
        var callback = function () {
            return self.$('#message-save').hide();
        };
        super.execute("EMAIL", "message.confirmemailsendtitle", self.confMessage,
            callback, callback);
    }

    validateVoucher() {
        return super.validateService("voucher");
    }

    validateSurvey() {
        return super.validateService("survey");
    }

    onEditMsgEditor() {
        this.showHideFooter(false);
    }

    onCancelMsgEditor(el) {
        this.showHideFooter(true);
        this.confMessage = this.$('#message-editable')[0].revert;
        this.once = false;
        this.isTriggeredByKeyPress = false;
        this.cleanUnusedUurlOptions(el);
        //TODO Check if here is the best place for this
        this.validateMessageCondition();
    }

    onSubmitMsgEditor(el) {
        this.showHideFooter(true);
        this.isTriggeredByKeyPress = false;
        this.confMessage = $(el).find("form").find("iframe").contents().find("body").html();
        this.cleanUnusedUurlOptions(el);
        this.hideSpamReportsWhileChecking(); //hide the Report tabels, while the "email is being processed message is visible

        this.checkForInvalidServicesAndClearThem();
        this.validateMessageCondition();
    }

    hideSpamReportsWhileChecking() {
        console.info("Checking for Spam or Spoof...");
        this.isSpamPhisCheckActive = true;
        $("#spamResultSection").hide();
        $("#phishingResultSection").hide();
    }

    onSubmitEmailSubject() {
        this.hideSpamReportsWhileChecking();
        this.validateMessageCondition();
    }

    toggleButtons(b, ref) {
        var self = ref || this;
        this.toggleExecuteButton(b, self);
        this.toggleTestButton(b, self);
    }

    cleanUnusedUurlOptions(el) {
        super.cleanUnusedUurlOptions(el);
    }

    customExec(self, text) {
        self.focus();
        self.insertText(text);
    }

    customUurlExec(self, href, title) {
        self.focus();
        var selectedText = self.getSelection().getSelectedText();
        var newNode = new window.CKEDITOR.dom.element("a");
        newNode.setAttributes({
            href: href,
            title: title,
            target: '_blank'
        });
        if (selectedText) {
            newNode.setText(selectedText);
        } else {
            newNode.setText(title);
        }
        self.insertElement(newNode);
        this.confMessage = self.getData();
    }

    customGenderExec(self, title) {
        self.focus();
        var selectedText = self.getSelection().getSelectedText();
        var newNode = new window.CKEDITOR.dom.element("span");
        if (selectedText && title.startsWith("[")) {
            if (title.startsWith("[M[")) {
                newNode.setText("[M[" + selectedText + "]]");
            } else if (title.startsWith("[F[")) {
                newNode.setText("[F[" + selectedText + "]]");
            } else if (title.startsWith("[O[")) {
                newNode.setText("[O[" + selectedText + "]]");
            } else if (title.startsWith("[N[")) {
                newNode.setText("[N[" + selectedText + "]]");
            }
        } else {
            newNode.setText(title);
        }
        self.insertElement(newNode);
        this.confMessage = self.getData();
    }

    updateMessageCount() {
        super.updateMessageCount({});
    }

    selectEditor(e, scope) {
        $("#select-editor").remove();
        var $e = $(e.currentTarget);
        if ($e.attr('id') === 'select-rich-editor') {
            $("#editor-tile, .email-footer").removeClass("hide");
            $("#message-editable").click();
        } else
            scope.enterMosaico(scope, null, $e.data("layout"));
    }

    enterMosaico(scope, tmplname, layout) {

        var selLayout = layout && require("../models/mosaico/" + layout + ".json");

        var self = scope;
        tmplname = tmplname || "versafix-tellody";
        var messageId = self.model.get("id");
        var d = new Date();
        var template = 'templates/' + tmplname + '/template-' + tmplname + '.html';
        var nEdit = {
            created: Date.now(),
            key: messageId,
            name: tmplname,
            template: template
        };
        if (self.model.get("template"))
            window.location = '/CampaignCloud/mosaico/editor.html#' + messageId;
        else
            $.ajaxDefaultQ({
                url: '/CampaignCloud/mosaico/config/' + messageId,
                type: 'POST',
                data: {
                    metadata: JSON.stringify(nEdit),
                    template: selLayout ? JSON.stringify(selLayout) : null,
                    export: null
                }
            }).done(function (response) {
                if (response.outcome === "OK") {
                    window.location = '/CampaignCloud/mosaico/editor.html#' + messageId;
                } else
                    location.reload();
            }).fail(function () {
                $.Notify.error(i18n.t("message.mosaicofailed"));
            });
    }

    //this one could be used for mosaico, in order to open it separately from tellody.
    openInToolWindow(url, toolname) {
        var newwindow = window.open("url", toolname || "tool");
        if (window.focus) {
            newwindow.focus();
        }
    }

    showHideFooter(show) {
        var $message = $("#message-editable + .email-footer");
        if (show) {
            $message.show();
        } else {
            $message.hide();
        }
    }

    showAndHideThemesAccordingToFilters(searchText, templates) {
        var templatesToBeShown = [];
        if (!searchText) {
            _.each(templates, function (template) {
                $(template).css("display", "inline-block");
            });
        } else {
            templatesToBeShown = _.filter(templates, function (template) {
                var templateLanguageName = $(template).find(".templateSelection").data("layout");
                return $(template).data("tags").toLowerCase().indexOf(searchText) > -1;
            });
            $(templates).hide();
            _.each(templatesToBeShown, function (template) {
                $(template).css("display", "inline-block");
            });
        }

        var $resultsDiv = $("#filteredEmailThemesResults");
        var $resultsCounterAndText = $resultsDiv.find(".filteredTextResult");

        if (!searchText && !templatesToBeShown.length) { //show All without filters
            $resultsDiv.hide();
        } else if (searchText && !templatesToBeShown.length) { //filtered, nothing found
            $resultsCounterAndText.text(i18n.t('message.noResultsFound'));
            $resultsDiv.show();
        } else {
            $resultsCounterAndText.text(searchText + ": " + i18n.t('message.foundXResults', {count: templatesToBeShown.length}));
            $resultsDiv.show();
        }
    }
}

export default MessageMailView;
